import { gql } from '@apollo/client';

export const SET_AI_SEARCH_ENABLED = gql`
  mutation SetAiSearchEnabled($enabled: Boolean!) {
    setAiSearchEnabled(enabled: $enabled)
  }
`;
